<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" class="px-0 pt-0 border-right">
                <v-subheader>Présentation</v-subheader>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>Basic</v-list-item-title>
                    <v-list-item-subtitle>
                      <div
                        v-if="
                          group.portalConfiguration.basic_presentation !=
                            null &&
                          group.portalConfiguration.basic_presentation.access !=
                            null &&
                          group.portalConfiguration.basic_presentation.access
                            .length > 0
                        "
                      >
                        {{
                          group.portalConfiguration.basic_presentation.access
                            .toString()
                            .toUpperCase()
                        }}
                        ({{
                          group.portalConfiguration.basic_presentation.payment
                        }})
                      </div>
                      <div v-else>-</div>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Full</v-list-item-title>
                    <v-list-item-subtitle>
                      <div
                        v-if="
                          group.portalConfiguration.full_presentation != null &&
                          group.portalConfiguration.full_presentation.access !=
                            null &&
                          group.portalConfiguration.full_presentation.access
                            .length > 0
                        "
                      >
                        {{
                          group.portalConfiguration.full_presentation.access
                            .toString()
                            .toUpperCase()
                        }}
                        ({{
                          group.portalConfiguration.full_presentation.payment
                        }})
                      </div>
                      <div v-else>-</div>
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" md="6" class="px-0 pt-0 border-right">
                <v-subheader>Profil</v-subheader>
                <portal-options-summary-card
                  :is-readonly="!isGrantedUser()"
                  :partner="group.partner"
                  :portal-options.sync="group.portalOptions"
                ></portal-options-summary-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <catalog-card :group="group"></catalog-card>
  </div>
</template>
<script>
import { defineComponent } from "@vue/composition-api";
import CatalogCard from "@/components/Group/CatalogCard";
import PortalOptionsSummaryCard from "@/components/PortalOptions/PortalOptionsSummaryCard";
import { useRoles } from "../../composables/roles";

export default defineComponent({
  components: {
    PortalOptionsSummaryCard,
    CatalogCard,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { isGrantedUser } = useRoles();

    return { isGrantedUser };
  },
});
</script>
